import { GiftCardStatus } from '@one-tree/library'
import React, { ReactElement } from 'react'
import {
  getGiftCardInvalidReason,
  isGiftCardValid,
} from '../../../../helpers/GiftCardHelper'
import { transformDate, TransformDateFormat } from '../../../../helpers/DateHelper'
import { OrganisationFormat } from '../../../../types/Types'

interface IValidityRowProps {
  status: GiftCardStatus
  organisationFormat: OrganisationFormat | undefined
  justRedeemed: boolean
  startDate?: number
}

function ValidityRow(props: IValidityRowProps): ReactElement | null {
  const {
    status, organisationFormat, justRedeemed, startDate,
  } = props

  const isFutureStart = startDate && startDate > Date.now() / 1000

  if (!justRedeemed && isFutureStart) {
    return (
      <tr>
        <th>Invalid reason</th>
        <td>
          {`This voucher is not valid until ${transformDate(startDate, TransformDateFormat.LongWithoutTime)}`}
        </td>
      </tr>
    )
  }

  return !isGiftCardValid(status) && !justRedeemed ? (
    <tr>
      <th>Invalid reason</th>
      <td>{getGiftCardInvalidReason(status, organisationFormat)}</td>
    </tr>
  ) : null
}
export default ValidityRow
